import { bridge, type SocketConnectionStatus, type SocketType } from "@innoclouds/sdk";

type SocketLike = {
	on: (event: string, callback: (data?: unknown) => void) => () => void;
};

export function reportSocketStatus(type: SocketType, url: string, status: SocketConnectionStatus) {
	bridge.emit("socketStatus", { type, url, status });
}

/**
 * Subscribe open / close / reconnect → bridge `socketStatus`.
 * Returns a single disposer (same shape as `ws.on`), safe to put in `wsUnsubscribers`.
 */
export function bindSocketStatusReporting(ws: SocketLike, type: SocketType, url: string): () => void {
	const unsubscribers = [
		ws.on("open", () => reportSocketStatus(type, url, "open")),
		ws.on("close", () => reportSocketStatus(type, url, "closed")),
		ws.on("reconnect", () => reportSocketStatus(type, url, "reconnect")),
	];
	return () => {
		for (const unsub of unsubscribers) unsub();
	};
}
